import { parseEditionYear } from './eventRouting';

/**
 * Build schedule / leaderboard / prizes paths with optional ?event= and /:year/ prefix.
 * @param {{ eventQueryId?: string, editionYearParam?: string|null, editionYearFallback?: string|number|null }} args
 * @returns {{ schedule: string, leaderboard: string, prizes: string, liveHub: string }}
 */
export function buildPublicEventNavPaths({
  eventQueryId = '',
  editionYearParam = null,
  editionYearFallback = null,
} = {}) {
  const eid = (eventQueryId || '').toString().trim();
  const qs = eid ? `?event=${encodeURIComponent(eid)}` : '';
  const y = parseEditionYear(editionYearParam);
  const prefix = y ? `/${y}` : '';
  const yHub = parseEditionYear(editionYearParam) ?? parseEditionYear(editionYearFallback);
  const liveHub = (() => {
    if (yHub) return `/${yHub}`;
    const dash = new URLSearchParams();
    if (eid) dash.set('event', eid);
    const d = dash.toString();
    return d ? `/dashboard?${d}` : '/dashboard';
  })();
  return {
    schedule: `${prefix}/schedule${qs}`,
    leaderboard: `${prefix}/leaderboard${qs}`,
    prizes: `/what-can-i-win${qs}`,
    liveHub,
  };
}
